import React from "react";

const HEIGHTS = { sm: 20, md: 24, lg: 30, xl: 40 };

export function BrandMark({ size = "md", className = "", "data-testid": testId }) {
  const h = HEIGHTS[size] || HEIGHTS.md;
  return (
    <img
      src="/tt-logo.webp"
      alt="Thick & Thin"
      data-testid={testId || "brand-logo"}
      draggable={false}
      className={`block select-none shrink-0 ${className}`}
      style={{ height: h, width: "auto", maxWidth: "none", objectFit: "contain" }}
    />
  );
}

export default BrandMark;
